import { forwardRef, InputHTMLAttributes } from 'react';
import clsx from 'clsx';

export const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & { className?: string }
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={clsx(
      'block w-full rounded-md border border-input bg-background text-foreground px-3 py-2 text-sm outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:border-ring placeholder:text-muted-foreground',
      className
    )}
    {...props}
  />
));
Input.displayName = 'Input';
